import styled from '@emotion/styled';
import { MenuItemsNavigation } from 'src/components/Menu/Menu.style';

export const MenuItemsNavigationFraud = styled(MenuItemsNavigation, { label: 'MenuItemsNavigationFraud' })`
    flex: 0 0 248px;
    width: 248px;
`;
